

























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { CollectionFlag, Prefix } from '@/types'

export interface InputOfReserveContactSituationBibliographyInfoItem {
  displayMaterialFormat: SystemCode
  displayClass: string
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  collectionFlag: CollectionFlag
  displayAuthor: string
  displayPublisher: string
  bibliographyId: number
}

export const defaultInputOfReserveContactSituationBibliographyInfoItem = (): InputOfReserveContactSituationBibliographyInfoItem => ({
  displayMaterialFormat: defaultSystemCode(),
  displayClass: '',
  prefix: Prefix.Real,
  searchType: defaultSystemCode(),
  displayTitle: '',
  collectionFlag: CollectionFlag.NotCollection,
  displayAuthor: '',
  displayPublisher: '',
  bibliographyId: 0
})

@Component({
  components: { IconBibliography }
})
export default class InputOfReserveContactSituationBibliographyInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: InputOfReserveContactSituationBibliographyInfoItem

  get bibliographyId() {
    if (this.item.bibliographyId < 1) {
      return ''
    }
    return (
      this.item.prefix + this.item.bibliographyId.toString().padStart(10, '0')
    )
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }
}
